import {
  Component,
  Input,
  OnInit,
  TemplateRef,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import {
  LearmoModalRef,
  LearmoModalService,
} from '../../../../shared/services/learmo-modal.service';

@Component({
  selector: 'app-messenger-chat-popup',
  templateUrl: './messenger-chat-popup.component.html',
  styleUrls: ['./messenger-chat-popup.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class MessengerChatPopupComponent implements OnInit {
  @Input() modalRef: LearmoModalRef;

  @ViewChild('modalContent') modalContent: TemplateRef<any>;

  constructor(private modalService: LearmoModalService) {}

  ngOnInit(): void {}

  async open(content?) {
    // this.onOpenModal();
    this.modalRef = this.modalService.open(this.modalContent, {
      title: null, // No default title, using custom header in template
      premium: true,
      size: 'lg',
      centered: true,
    });
  }
}
